// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.e-sidebar {
  margin-top: 45px !important;
  height: calc(100% - 20px) !important;
  overflow: hidden !important;
  background-color: var(--backgroundColor) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/modules/navigation/styles.css"],"names":[],"mappings":";AACA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,2BAA2B;EAC3B,mDAAmD;AACrD","sourcesContent":["\n.e-sidebar {\n  margin-top: 45px !important;\n  height: calc(100% - 20px) !important;\n  overflow: hidden !important;\n  background-color: var(--backgroundColor) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
